<template>
<div>
  <div class="topdiv ztop mtopdiv fs0">
    <div class="htmldiv pb20">
      <router-link to="/">
        <img src="../../assets/images/index_01_07.png" />
      </router-link>

    </div>　        　　                    　　        　
  </div>
  <div class="bg-m">
    <div class="htmldiv psearch">
      <span class="fs26 twhite vcenter">我们可以帮您的？</span>
      <div class="searchdiv prelative dinline-block vcenter">
        <div class="pinput br5 prelative ofhidden dinline-block bgw tleft" style="box-shadow: none;">
          <input class="input dinline-block fs18" name="" v-model="keyword" placeholder="请输入关键字搜索">
          <a class="zbtn pabsolute trans3 fs18 twhite" href="javascript:void(0);" @click="searchData">搜索</a>
        </div>
      </div>
      <div class="prelative fs18 twhite hot mt25 lh18">
        <div class="pabsolute nt">热词：</div>
        <a href="javascript:;" class="twhite mr20" v-for="(item,index) in hostList" @click="setKeyword(item)">{{item}}</a>
      </div>
    </div>
  </div>

  <div class="maindiv search-wrap bg-gray">
    <div class="htmldiv">
      <div class="stab fs18 pt25 pb5 prelative">
        <span class="pabsolute pl10">信息分类：</span>
        <a href="javascript:void(0)" class="mr30" data-key="0" :class="{active:(theme==0)}"  @click="setTheme(0)">全部内容</a>
        <a href="javascript:;" class="mr30" data-key="1" :class="{active:(theme==index)}" v-for="(item,index) in themeGroup" @click="setTheme(index)">{{item}}</a>
      </div>
      <div class="bgw">
        <div class="scont bgw">
          <!--显示10条-->
          <search-item v-for="(item,index) of list" :key="index" :item="item" :index="index" :keyword="keyword"/>
        </div>
        <div class="page tcenter">
          <Pagec v-if="total>0" :pagen="page" :size="size" :total="total" :pageClass="'page-blue'" @get-data="getData"/>
        </div>
      </div>
    </div>
    <div class="ht20"></div>
  </div>
</div>
</template>

<script>
import Pagec from './page'
import SearchItem from './search-item'
export default {
  name: "search",
  data () {
    return {
      keyword:'',
      theme:0,
      total:0,
      page:1,
      size:10,
      hostList:[],
      themeGroup:[],
      list:[],
    }
  },
  created() {
    this.getTitle();
    this.setKeyword(this.$route.query.keyword);
  },
  methods:{
    setTheme:function(theme){
      this.theme = theme;
      this.getData(1);
    },
    setKeyword:function(keyword){
      this.keyword = keyword;
      this.getData(1);
    },
    getTitle:function(){
      this.$request.get('home/search-index',[],response => {
        if(response.status == 200){
          this.hostList = response.data.data.hotList;
          this.themeGroup = response.data.data.themeGroup;
        }
      },error => {
        console.log(error);
      })
    },
    getData:function (page) {
      if(this.keyword == '' || this.keyword == undefined){
        return false;
      }
      var getParam = {};
      getParam['theme'] = this.theme;
      getParam['content'] = this.keyword;
      getParam['page'] = page - 1;
      getParam['size'] = this.size;
      this.$request.get('article/search-article',getParam,response => {
        if(response.status == 200){
          this.list = response.data.data.articleList;
          this.total = response.data.data.count;
        }
      },error => {
        console.log(error);
      })
    },
    searchData:function(){
      this.getData(1);
    },
  },
  mounted() {
  },
  components:{
    SearchItem,
    Pagec,
  }
}
</script>

<style scoped>
  .psearch{padding: 40px 40px 20px 140px;}
  .psearch .pinput{width: 695px;height: 52px;line-height: 52px;background: #ecc827;}
  .psearch .pinput .input{padding: 0 15px;width: 605px;height: 52px;line-height: 52px;}
  .psearch .pinput .zbtn{width: 90px;background: none;}
  .psearch .hot{padding-left: 60px;height: 60px;overflow: hidden;}
  .psearch .nt{left: 0;}

  .stab{padding-left: 105px;}
  .stab .pabsolute{left: 0;}
  .stab a{display: inline-block;margin-bottom: 10px;padding: 0 0 5px;border-bottom: 2px solid transparent;}
  .stab a:hover{color: #063674;}
  .stab .active{font-weight: bold;border-color: #063674;}
  .scont{padding: 50px 50px 20px;}
</style>



// WEBPACK FOOTER //
// src/components/index/search.vue